/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Injector,
  Input,
} from '@angular/core';

import { GridFeature, GridHoverSelectBarFeature, GridSelectBarFeature } from '../../features';
import { AbstractGridSelectBarFeature } from '../../features/select-bar/abstract-grid-select-bar-feature';
import { GridSelectBarTemplateDirective } from './grid-select-bar-template.directive';

@Component({
  standalone: false,
  selector: 'gh-grid-select-bar',
  template: '',
  providers: [GridSelectBarFeature, GridHoverSelectBarFeature],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSelectBarComponent implements AfterContentInit {
  @Input() showOnHover: boolean;
  @ContentChild(GridSelectBarTemplateDirective, { static: false }) private template: GridSelectBarTemplateDirective;

  private _suppressedEvents: string[] = ['click'];
  private feature: AbstractGridSelectBarFeature;

  constructor(private injector: Injector) {
  }

  @Input()
  set suppressedEvents(events: string | string[]) {
    this._suppressedEvents = Array.isArray(events) ? events : events.split(' ');
  }

  ngAfterContentInit(): void {
    this.feature = this.showOnHover
      ? this.injector.get(GridHoverSelectBarFeature)
      : this.injector.get(GridSelectBarFeature);

    this.feature.setSuppressedEvents(this._suppressedEvents);
    this.feature.setTemplateRef(this.template.templateRef);
  }

  getFeature(): GridFeature {
    return this.feature;
  }
}
